export function putThirdPartyInfo({ jwt, params }) {
  const newThirdPartyInfo = {
    thirdparty_agree_basic_dcm: params.thirdpartyAgreeBasicDcm,
    thirdparty_agree_basic_dpt: params.thirdpartyAgreeBasicDpt,
    thirdparty_agree_basic_corp: params.thirdpartyAgreeBasicCorp,
    thirdparty_agree_Biz_dcm: params.thirdpartyAgreeBizDcm,
    thirdparty_agree_Biz_dpt: params.thirdpartyAgreeBizDpt,
    thirdparty_agree_Biz_corp: params.thirdpartyAgreeBizCorp,
    thirdparty_agree_user_dcm: params.thirdpartyAgreeUserDcm,
    thirdparty_agree_user_dpt: params.thirdpartyAgreeUserDpt,
    thirdparty_agree_user_corp: params.thirdpartyAgreeUserCorp,
    thirdparty_agree_location_dcm: params.thirdpartyAgreeLocationDcm,
    thirdparty_agree_location_dpt: params.thirdpartyAgreeLocationDpt,
    thirdparty_agree_location_corp: params.thirdpartyAgreeLocationCorp,
    thirdparty_agree_health_dcm: params.thirdpartyAgreeHealthDcm,
    thirdparty_agree_health_dpt: params.thirdpartyAgreeHealthDpt,
    thirdparty_agree_health_corp: params.thirdpartyAgreeHealthCorp,
    thirdparty_agree_other_dcm: params.thirdpartyAgreeOtherDcm,
    thirdparty_agree_other_dpt: params.thirdpartyAgreeOtherDpt,
    thirdparty_agree_other_corp: params.thirdpartyAgreeOtherCorp,
  }
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/putThirdPartyInfo`, {
    method: "PUT",
    body: JSON.stringify(newThirdPartyInfo),
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}
